import type { IconSvgObject } from './types';

const KeyframeAddIcon: IconSvgObject = [
  ["path", { d: "M15.9999 12.6696L10.7298 6.67215C9.94224 5.77596 8.55792 5.77595 7.77038 6.67214L2.50008 12.6695C1.83331 13.4283 1.83331 14.5717 2.50008 15.3305L7.77038 21.3279C8.55792 22.2241 9.94224 22.224 10.7298 21.3278L15.9999 15.3304C16.6667 14.5717 16.6667 13.4283 15.9999 12.6696Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.9998 8L18.9998 2M15.9998 5H21.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default KeyframeAddIcon;
